import { render } from "./EditObject.vue?vue&type=template&id=23835c4a&scoped=true"
import script from "./EditObject.vue?vue&type=script&lang=js"
export * from "./EditObject.vue?vue&type=script&lang=js"

import "./EditObject.vue?vue&type=style&index=0&id=23835c4a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23835c4a"]])

export default __exports__